import { render } from "./LanguagePackage.vue?vue&type=template&id=24cc080a&scoped=true"
import script from "./LanguagePackage.vue?vue&type=script&lang=js"
export * from "./LanguagePackage.vue?vue&type=script&lang=js"

import "./language-package.scss?vue&type=style&index=0&id=24cc080a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cc080a"]])

export default __exports__